import CustomDate from '../../common/custom-date';
import {INSPECTION_STATE, INSPECTION_STATE_COLOR, INSPECTION_STATE_CODE} from '../../../constants/app/inspection';
import CustomUrl from '../../../lib/common/custom-url'
import {
    WITHOUT_SPARE_TIRE
} from '../../../constants/app/files';
import {
    USE_VEHICLE,
    TYPE_ENERGY
} from '../../../constants/app/vehicle';
import {
    ROUTE_DASHBOARD_INSPECTIONS
} from '../../../constants/routes/routes-ui';
import timeago from 'time-ago';

class InspectionTransform {
    static transformImages(files, type, codeName) {
        switch (codeName) {
            case 'accessoryCode':
                return InspectionTransform.transformImagesAccessories(files, type);
            default:
                return files.map((file) => {
                    return {
                        src: (file.files.length ? file.files[0].uri : (file.pictureCode === 'UP') ? '' : WITHOUT_SPARE_TIRE.src),
                        thumbnail: (file.files.length ? file.files[0].thumbnail : (file.pictureCode === 'UP') ? '' : WITHOUT_SPARE_TIRE.src),
                        caption: type[file[codeName]] || '',
                        thumbnailWidth: file.pictureCo0de === 'UP' ? null : 180,
                        isSelected: file.selected || false,
                        id: file.pictureCode === 'UP' ? null : file.id
                    }
                });
        }
    }

    static getImageItem(file, caption, defaultImage = '', selected = false, id) {
        if (file) {
            return {
                src: file.uri,
                thumbnail: file.thumbnail,
                caption,
                thumbnailWidth: 180,
                isSelected: selected || false,
                id
            }
        } else {
            return {
                src: defaultImage,
                thumbnail: defaultImage,
                caption,
                thumbnailWidth: 180,
                isSelected: selected || false
            }
        }
    }

    static transformImagesAccessories(files, type) {
        let images = [];
        files.forEach((file) => {
            switch (true) {
                case file.accessoryCode === 'WHEEL':
                case file.accessoryCode === 'RIM':
                    break;
                default:
                    images.push(InspectionTransform.getImageItem(file.files[0], type[file.accessoryCode], '', file.selected, file.id));
            }

        });
        return images;
    }

    static getPictureTitle(cod, type) {
        const picture = type.find((file) => file.id === cod)
        return picture;
    }

    static getVehicleDesc(cod, type) {
        let value = '';
        if (type === USE_VEHICLE.COD) {
            value = USE_VEHICLE.OPTIONS.find((opt) => opt.id === cod);
            return value
        } else {
            value = TYPE_ENERGY.OPTIONS.find((opt) => opt.id === cod);
            return value;
        }
    }

    static colorDate(startDate) {
        const now = new Date();
        let countDays = now - new Date(startDate);
        const getSeconds = countDays / 1000;
        const getMinuts = getSeconds / 60;
        const getHours = getMinuts / 60;
        let color;
        if (getHours >= 40) {
            color = 'text-red';
        } else {
            color = 'text-black';
        }
        return color;
    }

    static colorState(state) {
        let item = {
            color: '',
            text: ''
        };

        switch (state) {
            case INSPECTION_STATE.DRAFT: // borrador
                item = {
                    color: 'text-gray',
                    text: 'Borrador'
                };
                break;
            case INSPECTION_STATE.CREATE: // creado
                item = {
                    color: 'text-gray',
                    text: 'Creado'
                };
                break;
            case INSPECTION_STATE.DERIVE: // derivado
                item = {
                    color: 'text-orange',
                    text: 'En suscripción'
                };
                break;
            case INSPECTION_STATE.RETURN: // devuelto
                item = {
                    color: 'text-lg',
                    text: 'Devuelta'
                };
                break;
            case INSPECTION_STATE.APPROVED: // aprobado
                item = {
                    color: 'text-green',
                    text: 'Aprobado'
                };
                break;
            case INSPECTION_STATE.REJECTED: // recahzado
                item = {
                    color: 'text-red',
                    text: 'Rechazado'
                };
                break;
            case INSPECTION_STATE.SENT: // en tramite
                item = {
                    color: 'text-orange',
                    text: 'En trámite'
                };
                break;
            default:
                item = {};
        }
        return item;
    }

    static transformTable(item) {
        let state = {};
        let isChangeToPresential = {
            state: 0,
            title: ''
        }
        let client = {names: '', firstSurname: '', lastSurname: ''};
        client = item.client;
        const timeAgo = (item.state && item.state.date && item.state.date.length) ? timeago.ago(item.state.date) : '';
        item.states = item.states || [];
        if (item.states.length && item.states[0].inspectionStatus === INSPECTION_STATE_CODE.CREATE) {
            isChangeToPresential = {
                state: 1,
                title: 'Creada',
                text: 'Esta inspección no contiene información para poder ser revisada.'
            };
        }
        if (item.states.length && item.states[0].inspectionStatus === INSPECTION_STATE_CODE.DRAFT) {
            isChangeToPresential = {
                state: 1,
                title: 'en Borrador',
                text: 'Esta inspección no contiene la información completa para poder ser revisada.'
            };
        }
        if (item.states.length && item.states[0].inspectionStatus === INSPECTION_STATE_CODE.SENT && item.states[1].inspectionStatus === INSPECTION_STATE_CODE.RETURN) {
            state = {
                color: 'text-orange',
                text: 'En trámite - Reingreso'
            }
        } else {
            state = INSPECTION_STATE_COLOR[item.state.inspectionStatus] || {color: '', text: ''};
        }
        const transaleDate = timeAgo ? timeAgo.replace('second', 'segundo').replace('seconds', 'segundos').replace('ago', 'hace').replace('hour', 'hora').replace('hours', 'horas').replace('minutes', 'minutos').replace('minute', 'minuto').replace('days', 'días').replace('day', 'día').replace('weeks', 'semanas').replace('week', 'semana').replace('months', 'meses').replace('month', 'mes').replace('year', 'año').replace('years', 'años').split(" ") : '';
        const setFormatDate = timeAgo ? `${transaleDate[2]} ${transaleDate[0]} ${transaleDate[1]}` : '';

        return [
            {
                primaryText: item.stateCreate ? CustomDate.getFormatDate(item.stateCreate.date) : '',
                primaryColor: 'text-black',
                secondaryText: setFormatDate,
                secondaryColor: item.lastStateSent ? InspectionTransform.colorDate(item.lastStateSent.date) : '',
                isCancel: false
            },
            {
                primaryText: item.policyNumber,
                primaryColor: 'text-black',
                secondaryText: '',
                secondaryColor: '',
                isCancel: false
            },
            {
                primaryText: (client) ? `${(client.names || '').toLowerCase()} ${(client.firstSurname || '').toLowerCase()} ${(client.lastSurname || '').toLowerCase()}` : '',
                primaryColor: 'text-black capitalize',
                secondaryText: `${item.documentType} ${item.documentNumber}`,
                secondaryColor: 'text-light--md',
                isCancel: false
            },
            {
                primaryText: item.vehiclePlate,
                primaryColor: 'text-black',
                secondaryText: `${(item.vehicleBrand || '').toLowerCase()} ${(item.vehicleModel || '').toLowerCase()}`,
                secondaryColor: 'capitalize',
                isCancel: false
            },
            {
                primaryText: item.vehicleMotor,
                primaryColor: 'text-black',
                secondaryText: '',
                secondaryColor: '',
                isCancel: false
            },
            {
                primaryText: item.vehicleChasis,
                primaryColor: 'text-black',
                secondaryText: '',
                secondaryColor: '',
                isCancel: false
            },
            {
                primaryText: state.text || '',
                primaryColor: state.color,
                secondaryText: '',
                secondaryColor: '',
                isLink: state.text,
                isChangeToPresential: {...isChangeToPresential, userIdentity: item.userIdentity, requestId: item.id},
                url: CustomUrl.getURL(ROUTE_DASHBOARD_INSPECTIONS, {
                    userIdentity: item.userIdentity,
                    requestId: item.id
                }, false),
                isCancel: !!(state && state.text.length > 0 && state.text === 'Cancelado')
            }
        ];
    }
}

export default InspectionTransform;



// WEBPACK FOOTER //
// ./src/lib/utils/transforms/inspections.js